var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"view-ui-button-signup button-primary",on:{"click":function($event){return _vm.$emit('signup')}}},[_vm._v("Join for Free")])
}
var staticRenderFns = []

export { render, staticRenderFns }